import type { RouteRecordRaw } from 'vue-router'

// 活动
const routes: Array<RouteRecordRaw> = [
  {
    path: '/officialActivity/details',
    name: 'officialActivityDetails',
    meta: {
      title: '', //活动详情
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/officialActivity/details/index.vue'),
  },
  {
    path: '/officialActivity/member',
    name: 'officialActivityMember',
    meta: {
      title: '报名成员列表', //活动详情-成员列表
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/officialActivity/member/index.vue'),
  },
  {
    path: '/officialActivity/sign',
    name: 'officialActivitySign',
    meta: {
      title: '活动报名',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/officialActivity/sign/index.vue'),
  },
  {
    path: '/officialActivity/signResult',
    name: 'officialActivitySignResult',
    meta: {
      title: '',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/officialActivity/signResult/index.vue'),
  },
  {
    path: '/officialActivity/signDetail',
    name: 'officialActivitySignDetail',
    meta: {
      title: '', //预约记录
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/officialActivity/signDetail/index.vue'),
  },
  {
    path: '/officialActivity/checkIn',
    name: 'officialActivitycheckIn',
    meta: {
      title: '活动签到',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/officialActivity/checkIn/index.vue'),
  },
]

export default routes
